import { Component, OnInit ,ElementRef, Inject, ViewChild} from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { GatewayService } from 'src/app/gateway.service';
import * as jQuery from 'jquery';
import 'jquery-ui-dist/jquery-ui.min.js';
// import 'c3/c3.min.js';
import 'pivottable/dist/pivot.min.js';
// import 'pivottable/dist/c3_renderers.js';
import { Observable } from 'rxjs';
import { map, startWith, debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { Subscription } from 'rxjs/Subscription';
import { SelectCampanaService, BusquedaService } from '../../home/busqueda.service';
import { ComponentPageTitle } from '../../page-title/page-title.component';
//IMPORT POWERBI
import * as pbi from 'powerbi-client';
import { NgxPowerBiService } from 'ngx-powerbi';

@Component({
  selector: 'app-dashboardpivot',
  templateUrl: './dashboardpivot.component.html',
  styleUrls: ['./dashboardpivot.component.scss']
})
export class DashboardpivotComponent implements OnInit {
  private el: ElementRef;
  private powerBiService: NgxPowerBiService;
  private pbiContainerElement: HTMLElement;

  // gestionColumns: string[] = ['NOMBRE', 'TELEFONO', 'FECHA','CAMPANA', 'COMENTARIO', 'ESTADO', 'SELECTS'];
  gestionColumns: string[] = ['NOMBRE', 'TELEFONO', 'FECHA','CAMPANA', 'COMENTARIO', 'ESTADO'];
  dataSource = new MatTableDataSource<any>([]);
  FILTER: string = null;
  resultsLength: number = 0;
  pageSize = 8;
  pageEvent: PageEvent;
  altapv=-1;
  public actpage:number=0;
  actcampana;
  habilitarbusqueda:boolean=false;
  private subscription: Subscription;
  @ViewChild('paginatorgest') paginatorgest: MatPaginator;
  public estados=[
    {NOMBRE:'EJECUTADOS', VALOR:1, TOTAL:0},
    {NOMBRE:'NO EJECUTADOS', VALOR:0, TOTAL:0}
    ]

  displayedColumns: string[] = ['modalidad', 'plan', 'terminal', 'bodega', 'direccion','referencia'];
  displayedRows$: Observable<any[]>;

  constructor(
      private spinner: NgxSpinnerService,
      private gateway: GatewayService,
      @Inject(ElementRef)el: ElementRef,
      private localSave: LocalSaveService,
      private _selectCampana: SelectCampanaService,
      public pageTitle: ComponentPageTitle,
      public _busqueda: BusquedaService,
      public dialog: MatDialog
      ) { 
  	this.el = el;
    this.powerBiService = new NgxPowerBiService();
  }

  loadingoperativa = false;

  ngOnInit() {

      // this.spinner.show();
      // 	this.gateway.get('pivotsupervisor', {}).then((result) => {
		  // 	let aux:any = result;
			
		  // 	this.loadagenciapivot('operativa1',aux.rows,["CAMPAÑA","USUARIO","DIA","MES","AÑO"],["GESTIONES","VPH","CONTACTABILIDAD","CONVERSION","EFECTIVIDAD"],"Sum",'Table',["GESTIONES"]);

		  // 	//this.resultsLength = result.rows[0].total;
		  // 	this.spinner.hide();
		  // }
		  // ).catch(function (e) {
		  // });

    this.subscription = this._selectCampana.notifyObservableSC$.subscribe(
      res => {
        let auxres:any=res;
        this.actcampana=auxres.campana;
        this.altapv=-1;
        this.actpage=auxres.julito;
        this.get(this.actpage,this.actcampana,this.altapv)
    });

    // this.subscription = this._busqueda.notifyObservable$.subscribe(
    //     res => {
    //       if(this.habilitarbusqueda == true){
    //         this.filtrarcampana(res.filtro);
    //       }
    // });
  }

    public filterState(altapv,total){
      if(this.habilitarbusqueda === true && total !== 0){
      if (altapv !== this.altapv){
        this.altapv = altapv;
      } else {
        this.altapv = -1;
      }
        this.get(this.actpage,this.actcampana,this.altapv);
      }
    }

  get(page,idcampana,altapv) {
    if(page === 0){
      this.paginatorgest.firstPage();
    }
    const params = { NUM_PAGINA: page, FILTRO: this.FILTER, NUM_ELEMENTOS: this.pageSize, ALTAPOSTVENTA: altapv, IDCAMPANA: idcampana.toString(), IDROL:0 };
    this.spinner.show();
    this.gateway.get('getgestionespv', params).then((result: any) => {
      let gestiones = result.rows;
      this.dataSource = new MatTableDataSource(gestiones);
      this.displayedRows$ = gestiones;
        this.spinner.hide();
    }
    ).catch(function (e) {
    });

    this.gateway.get('getgestionespvcount', params).then((result: any) => {
      this.resultsLength = result.rows[0].total;
    });
    this.gateway.get('ejecutadoscount',{IDCAMPANA:idcampana.toString()}).then((result: any) => {
      this.estados[0].TOTAL=result.rows[0].total_ejecutados;
    })
    this.gateway.get('noejecutadoscount',{IDCAMPANA:idcampana.toString()}).then((result: any) => {
        this.estados[1].TOTAL=result.rows[0].total_noejecutados;
        this.habilitarbusqueda=true;
    })

  }
  public cambioElementos(event?: PageEvent) {
    this.actpage=event.pageIndex;
    this.get(this.actpage,this.actcampana,this.altapv);
  }

  tabChanged(event) {
    if (event.index === 1) {
        this.pageTitle.flagaux=false;
        this.showReport();
    }else if (event.index === 0){
        this.pageTitle.flagaux=true;
    }
  }

  loadagenciapivot(element,data,rows,cols,aggregator,typepivote,vals){
        if (!this.el ||
            !this.el.nativeElement ||
            !this.el.nativeElement.children){
                return;
         }

         const container = this.el.nativeElement;
         const inst = jQuery(container);
         const targetElement = inst.find('#'+element);

         if (!targetElement){
            return;
        }
        
        const renderers = jQuery.extend(jQuery.pivotUtilities.renderers,jQuery.pivotUtilities.c3_renderers);

        //this helps if you build more than once as it will wipe the dom for that element
        while (targetElement.firstChild){
            targetElement.removeChild(targetElement.firstChild);
        }

        //here is the magic
        targetElement.pivotUI( data,
                            {
                                rows: rows,
                                cols: cols,
                                vals: vals,
                                aggregatorName: aggregator,
                                rendererName: typepivote,
                                renderers:renderers
                            }
        );
 	}

  showReport() {
      // Report's Secured Token
      let accessToken = '';

      // Embed URL
      let embedUrl = 'https://embedded.powerbi.com/reportEmbed?';

      // Report ID
       // let embedReportId = '65e9222e-029d-4896-b64a-1752daf3d1ce'; // isoft
       // let embedReportId = '9bc8146f-7eb1-46a1-a4be-2034a0bc181e'; // mov desa
       let embedReportId = '8eb06997-aebd-464c-9422-eafd72faad71'; // mov prod

      // Group ID
      let embedGroupId = '1e41269c-5735-4eea-b24b-8471b8b980fe';

      this.gateway.get('gettokenbi', {}).then((result) => {
      //console.log(result);
      let auxres:any = result;

          const config = {
              type: 'report',
              id: embedReportId,
              embedUrl:
                embedUrl +
                'reportId=' +embedReportId+
                '&groupId='+ embedGroupId,
              accessToken: auxres.access_token,
              settings: {
                filterPaneEnabled: true,
                navContentPaneEnabled: true
              }
            };

          this.pbiContainerElement = <HTMLElement>(document.getElementById('pbi-container'));
          this.powerBiService.embed(this.pbiContainerElement, config);

          let report = <pbi.Report>this.powerBiService.embed(this.pbiContainerElement, config);

          // Report.off removes a given event handler if it exists.
          report.off("loaded");

          // Report.on will add an event handler which prints to Log window.
          report.on("loaded", function() {
              });
    }
    ).catch(function (e) {
    });
      
      
        
  }

}
